import React from 'react';
import { DropdownContentProps } from '../../DropdownContent/types';
import { UseMenuContextProps } from './types';

interface DropdownMenuContextProps {
    isDark: boolean;
}

export const DropdownMenuContext = React.createContext<
    (UseMenuContextProps & Pick<DropdownContentProps, 'fullWidth' | 'variant'> & DropdownMenuContextProps) | null
>(null);

const useMenuContext = () => {
    const context = React.useContext(DropdownMenuContext);

    if (!context) {
        throw new Error('Menu compound components cannot be rendered outside the DropdownMenu component');
    }

    return context;
};

export default useMenuContext;
